import { createSlice } from '@reduxjs/toolkit'
import { strapiFetch, StrapiApiError } from '../../api/strapi'

const slice = createSlice({
    name: 'projects',
    initialState: {
        data: null,
        loading: false,
        loaded: false,
        error: null,
        detail: null,
        detailLoading: false,
        detailError: null,
    },
    reducers: {
        setLoading: (state, action) => { state.loading = action.payload },
        setLoaded: (state, action) => { state.loaded = action.payload },
        setData: (state, action) => { state.data = action.payload },
        setError: (state, action) => { state.error = action.payload },
        setDetailLoading: (state, action) => { state.detailLoading = action.payload },
        setDetail: (state, action) => { state.detail = action.payload },
        setDetailError: (state, action) => { state.detailError = action.payload },
    },
})

export default slice.reducer

const { setLoading, setLoaded, setData, setError, setDetailLoading, setDetail, setDetailError } = slice.actions

const projectListPopulate = {
    'populate[category]': 'true',
    'populate[image]': 'true',
    'populate[image2]': 'true',
    'pagination[pageSize]': 100,
    'sort': 'rank:asc',
}

const projectDetailPopulate = {
    'populate[category]': 'true',
    'populate[image]': 'true',
    'populate[image2]': 'true',
    'populate[image3]': 'true',
    'populate[intro]': 'true',
    'populate[article][populate]': '*',
    'populate[article2][populate]': '*',
    'populate[locations]': 'true',
}

export const loadProjectsData = (locale) => async dispatch => {
    dispatch(setLoading(true))
    dispatch(setError(null))
    try {
        const [page, projects] = await Promise.all([
            strapiFetch('/api/projects-page', {
                locale,
                params: {
                    'populate[seo]': 'true',
                    'populate[banner][populate][bannerImage]': 'true',
                },
            }),
            strapiFetch('/api/projects', { locale, params: projectListPopulate }),
        ])
        dispatch(setData({ page: page.data, items: projects.data }))
        dispatch(setLoaded(true))
    } catch (e) {
        dispatch(setError(e instanceof StrapiApiError ? e.message : 'Failed to load projects page'))
    } finally {
        dispatch(setLoading(false))
    }
}

export const loadProjectBySlug = (slug, locale) => async dispatch => {
    dispatch(setDetailLoading(true))
    dispatch(setDetailError(null))
    try {
        const json = await strapiFetch('/api/projects', {
            locale,
            params: { 'filters[slug][$eq]': slug, ...projectDetailPopulate },
        })
        dispatch(setDetail(json.data[0] || null))
    } catch (e) {
        dispatch(setDetailError(e instanceof StrapiApiError ? e.message : 'Failed to load project'))
    } finally {
        dispatch(setDetailLoading(false))
    }
}
